import { motion } from "framer-motion";
import {
  Download,
  MessageCircle,
  PhoneCall,
  HeartPulse,
  Repeat,
} from "lucide-react";
import { siteContent } from "@/content/site";

const STEP_ICONS = {
  download: Download,
  message: MessageCircle,
  phone: PhoneCall,
  heart: HeartPulse,
  repeat: Repeat,
};

const { howItWorks } = siteContent;

export default function HowItWorks() {
  return (
    <section
      id="how"
      data-testid="how-section"
      className="relative py-20 lg:py-28 bg-[#F4FAF8]"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#E8A33D]">
            {howItWorks.eyebrow}
          </span>
          <h2 className="font-display mt-3 text-3xl sm:text-4xl lg:text-5xl font-bold text-[#0E2A36] leading-tight">
            {howItWorks.headingLead}{" "}
            <em className="italic font-medium text-[#1F4E5F]">
              {howItWorks.headingItalic}
            </em>{" "}
            {howItWorks.headingTail}
          </h2>
          <p className="mt-4 text-[#3D5560] text-lg">{howItWorks.subhead}</p>
        </div>

        <div className="relative">
          <div className="hidden lg:block absolute left-0 right-0 top-[44px] h-px bg-gradient-to-r from-transparent via-[#1F4E5F]/25 to-transparent" />
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6 lg:gap-4">
            {howItWorks.steps.map((s, i) => {
              const Icon = STEP_ICONS[s.iconKey] || Download;
              return (
                <motion.div
                  key={i}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "-60px" }}
                  transition={{ duration: 0.55, delay: i * 0.08 }}
                  className="relative flex flex-col items-center text-center"
                  data-testid={`how-step-${i + 1}`}
                >
                  <div className="relative z-10 w-[88px] h-[88px] rounded-3xl bg-[#F4FAF8] border border-[#C9DDD6] flex items-center justify-center group hover:bg-[#1F4E5F] transition-colors duration-300">
                    <Icon className="w-7 h-7 text-[#1F4E5F] group-hover:text-[#F4FAF8] transition-colors" />
                    <span className="absolute -top-2 -right-2 w-7 h-7 rounded-full bg-[#E8A33D] text-white font-display font-bold text-xs flex items-center justify-center shadow-sm">
                      {i + 1}
                    </span>
                  </div>
                  <h3 className="font-display mt-5 text-lg font-semibold text-[#0E2A36] leading-snug">
                    {s.title}
                  </h3>
                  <p className="mt-2 text-sm text-[#3D5560] leading-relaxed max-w-[220px]">
                    {s.body}
                  </p>
                </motion.div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
